<template lang="pug">
  Icon.icon(name="notification-play" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Пользователь хочет добавить Вас в
    a(:href="$router.resolve({ name: 'contacts' }).href")  контакты
</template>

<script>
export default {
  name: 'NotificationContactRequestCreated',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
